import type { SVGProps } from "react";
// generated from Lightning.svg — do not edit manually
// prettier-ignore
export default function Lightning(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 10 12 H 3 L 16.208 2 L 14 12 H 21 L 7.792 22 L 10 12 Z" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
